export default __webpack_public_path__ + "static/media/multi.b3f887c4.png";